import React from 'react';
import EqpMngContainer from '../../containers/eqpmng/EqpMngContainer';

const EqpMngPage = () => {
  return <EqpMngContainer />;
};

export default EqpMngPage;
